module.exports = __webpack_public_path__ + "static/media/megabus-ticket-lookup.7ab055ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/megabus-ticket-lookup.svg
// module id = 935
// module chunks = 0